
// TODO TFS1282622
// You can delete this fn and usages, or just remove the actual implementation, make it a noop, and do cleanup later.
// This is the only remaining use for ServiceLocator.
export function triggerDigest() {
  try {
    ServiceLocator.get<ng.IRootScopeService>('$rootScope').$applyAsync();
  } catch {
    // ignore the error since it only happens in unit tests if $rootscope is not injected
  }

}

namespace ServiceLocator {

  const CouldNotFindAppElementErrorMessage = 'Could not instantiate ServiceLocator: #app-root div could not be found!\n' +
      'The ServiceLocator cannot be used within unit tests, because it relies on a fully-instantiated Angular application.\n' +
      'If you encounter this error while running unit tests, it can be solved by doing one of the following:\n' +
      '  1. Refactor product code not to use ServiceLocator or wrap your component in an AngularProvider HOC (try this first!)\n' +
      '  2. If ServiceLocator is called from test code: Use `$inject` to inject dependencies for test code\n' +
      '  3. If ServiceLocator is called from product code: Use Sinon to stub `ServiceLocator.get` to return ' +
           'a service fetched with `$inject`';

  export function get<T>(serviceName: string): T {
    return getInjector().get<T>(serviceName);
  }

  const getAppElement: () => JQuery<HTMLElement> = (function() {
    let appElement: JQuery<HTMLElement>;

    return function getAppElement(): JQuery<HTMLElement> {
      if (!appElement) {
        appElement = angular.element('#app-root');
      }

      if (appElement.length === 0) {
        throw new Error(CouldNotFindAppElementErrorMessage);
      }

      return appElement;
    };
  })();

  // NOTE: Currently mobile does not support OpenID and Phoenix auth relies on this injector to
  // disable OpenID client-side. Plan is to work on supporting OpenID and remove the injected script
  // after that. Will update/remove this comment when that happens. See TFS 881459 for more info

  const getInjector: () => ng.auto.IInjectorService = (function() {
    let injector: ng.auto.IInjectorService;

    return function getInjector(): ng.auto.IInjectorService {
      if (!injector) {
        injector = getAppElement().injector();
      }
      return injector;
    };
  })();

}
